<span *ngIf="working">Loggar in...</span>
<span *ngIf="error">{{ error }}</span>
